import application from 'application/application';
import inputTypesTemplate from './input-types.template.html';

import inputTypesController from './input-types.controller.js';

application.directive('ngInputTypes', [
	() => ({
		restrict: 'E',
		scope: {
            title: '@',
            reload: '&'
        },
		templateUrl: inputTypesTemplate,
		controller: inputTypesController
	})
]);